import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { DEFAULT_ROUTES_BY_ROLE } from '@auth/consts/default-routes-by-role.const';
import { RbsService } from '@auth/services/rbs.service';
import { Url } from '@core/enums/url.enum';

export const hasSelectedRoleGuard: CanActivateFn = (_, state) => {
  const router = inject(Router);
  const rbsService = inject(RbsService);

  const isAuthLanding = state.url.startsWith(Url.AuthLanding);

  const userOrganizationList = rbsService.userOrganizationList();
  let selectedUserOrganization = rbsService.selectedUserOrganization();

  if (userOrganizationList.length === 1 && !selectedUserOrganization) {
    selectedUserOrganization = userOrganizationList[0];
    rbsService.selectedUserOrganization = selectedUserOrganization;
  }
  const role = selectedUserOrganization?.role ?? '';
  const defaultRoute = role && DEFAULT_ROUTES_BY_ROLE[role];

  if (defaultRoute) {
    return !isAuthLanding || router.createUrlTree([defaultRoute]);
  }

  return isAuthLanding || router.createUrlTree([Url.AuthLanding]);
};
